import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CheckInput, Input } from "../../../../../common/Input";

const ModuleAccessAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    allowSkipApproval: false,
    allowDepartedButton: false,
    allowArrivedButton: false,
    isEmployeeTransactionProcessManager: false,
    isEmployeeTransactionAssignedEmployee: false,
  });

  useEffect(() => {
    if (isOpen && selectedItem) {
      setForm({
        allowSkipApproval: !!selectedItem.allowSkipApproval,
        allowDepartedButton: !!selectedItem.allowDepartedButton,
        allowArrivedButton: !!selectedItem.allowArrivedButton,
        isEmployeeTransactionProcessManager: !!selectedItem.isEmployeeTransactionProcessManager,
        isEmployeeTransactionAssignedEmployee: !!selectedItem.isEmployeeTransactionAssignedEmployee,
      });
    }
  }, [selectedItem, isOpen]);

  // MODIFIED: Logic to determine mutual exclusivity
  const isProcessManagerAccess =
    form.allowSkipApproval ||
    form.allowDepartedButton ||
    form.allowArrivedButton ||
    form.isEmployeeTransactionProcessManager;

  const isAssignedEmployeeChecked = form.isEmployeeTransactionAssignedEmployee;

  const handleToggle = (field, val) => {
    setForm(prev => ({ ...prev, [field]: val }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto" style={{ marginTop: 0 }}>
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">Update Access Settings</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer p-0"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4">
          <Input label="Via Captain:" value={selectedItem?.description || ""} isDisabled={true} placeholder="-- No Data --" />

          <div className="border rounded-lg p-2 space-y-1">
            <h3 className="text-sm font-semibold px-2 mb-2 text-gray-500 uppercase">Process Manager Permissions</h3>

            <CheckInput
              name="Allow Skip Approval"
              value={form.allowSkipApproval}
              onChange={(val) => handleToggle("allowSkipApproval", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />
            <CheckInput
              name="Allow Departed Button"
              value={form.allowDepartedButton}
              onChange={(val) => handleToggle("allowDepartedButton", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />
            <CheckInput
              name="Allow Arrived Button"
              value={form.allowArrivedButton}
              onChange={(val) => handleToggle("allowArrivedButton", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />
            <CheckInput
              name="Process Manager"
              value={form.isEmployeeTransactionProcessManager}
              onChange={(val) => handleToggle("isEmployeeTransactionProcessManager", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />

          </div>

          <div className="border rounded-lg p-2 space-y-1">
            <h3 className="text-sm font-semibold px-2 mb-2 text-gray-500 uppercase">Assigned Employee Permissions</h3>

            <CheckInput
              name="Assigned Employee"
              value={form.isEmployeeTransactionAssignedEmployee}
              onChange={(val) => handleToggle("isEmployeeTransactionAssignedEmployee", val)}
              isEditMode={!isProcessManagerAccess}
            />
          </div>

          {(isProcessManagerAccess || isAssignedEmployeeChecked) && (
            <div className="border rounded-lg p-2 space-y-1">
              {isProcessManagerAccess && (
                <p className="text-xs text-orange-600 px-2 mt-2 italic">
                  * "Assigned Employee" is disabled because a Manager role is selected.
                </p>
              )}
              {isAssignedEmployeeChecked && (
                <p className="text-xs text-orange-600 px-2 mt-2 italic">
                  * Manager roles are disabled because "Assigned Employee" is selected.
                </p>
              )}
            </div>
          )}

        </div>


        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button onClick={() => onSave(form)} className="px-6 py-2 bg-blue-600 text-white rounded border-none cursor-pointer">Save Changes</button>
        </div>
      </div>
    </div>
  );
};

export default ModuleAccessAddEditModal;